
import { InputFieldObjV2 } from "services/InputFieldsTaxasV2"
import { AutoCompleteAddress } from "services/FormFunctions"
import { asBRL } from "services/CalcTaxaFunctions"
import { userLogado, userHasAccess } from "services/LoginFunctions"
import { autoFill, dropdownsAreValid, getFormData } from "services/FormFunctions"
import { PegarProcesso, SalvarDocumentoCriarProcesso, EditarDocumento } from "services/CallAPIs"
import { docField } from "services/InputFieldsDocumentos"
import { getField } from "hooks/useGerarDocumento"

import { criarDocBodyBD } from "models/BodyDocumentosBD"

import * as MSG from "constants/messages"
import { ROLE } from "constants/userRoles"
import { ErrorChamadaApi, SuccessDocumentoGerado, WarningIncompleteInputMessage } from "hooks/useAlert"
import { guiaField } from "services/InputFieldsGuia"

export const opcoesParcelamento = ["Sem parcelamento", "2 vezes", "3 vezes", "4 vezes", "5 vezes", "6 vezes"]

export function mapFieldPlaceholderToUnit(placeholder)
{
    if (placeholder === undefined) { return "" }

    if (placeholder.includes("m²")) { return " m²" }

    if (placeholder.includes("m")) { return " m" }

    if (placeholder.includes("R$")) { return " reais" }

    return ""
}

export function CalcularParcelas(taxaTotal, outorga, numParcelas, parcelarTaxaTotal)
{
    // no alvará parcela a taxa total, caso tenha início de obra, entra na primeira parcela
    // na regularização só parcela a outorga, que sempre tem

    const valorAParcelar = parcelarTaxaTotal ? taxaTotal : outorga
    const valorAdicionalPrimeiraParcela = parcelarTaxaTotal ? 0 : taxaTotal - outorga

    if (valorAParcelar === null || valorAParcelar === undefined) { return [taxaTotal] }
    
    let valoresParcelas = new Array(numParcelas)
    valoresParcelas.fill(valorAParcelar / numParcelas)
    valoresParcelas[0] += valorAdicionalPrimeiraParcela

    return valoresParcelas
}

export function determineParcelasTexto(parcelarTaxaTotal, parcelasPagamento, valoresParcelas)
{

    if (valoresParcelas === null || valoresParcelas === undefined) { return [] }

    const numParcelas = valoresParcelas.length
    let parcelasTexto = "\n\nTaxa parcelada em " + parcelasPagamento

    for (let i = 1 ; i <= numParcelas ; i += 1)
    {
        parcelasTexto += "\nValor da " + i + "a parcela = R$ " + asBRL(valoresParcelas[i - 1]) +
                            (parcelarTaxaTotal
                            ? " (1/" + numParcelas + " taxa de licença)"
                            : (i === 1
                                ? " (taxa de licença + vistoria + 1/" + numParcelas + " outorga)"
                                : " (1/" + numParcelas + " outorga)"))
    }

    return parcelasTexto
}

export function determineTaxData(detalhesDaAvaliacao, detalhesDoCalculo, taxaInputs)
{
    const msg = "Informações do empreendimento"
    let taxaDataText = "\n"
    let detAvalText = ""
    let detCalcText = ""
    if (taxaInputs)
    {
        
        let formattedTaxInputs = {...taxaInputs}
        Object.entries(formattedTaxInputs).forEach(entry =>
        {
            if (entry[1] === "on")
            {
                formattedTaxInputs[entry[0]] = "Sim"
            }
        })
        Object.keys(formattedTaxInputs).map(key => 
        {
            InputFieldObjV2(key)
            let value = formattedTaxInputs[key]
            if (key !== "caracteristicas" && key !== "tipoImovel" && value !== undefined)
            {
                const field = InputFieldObjV2(key)
                const taxText = field?.label + ": " + value + mapFieldPlaceholderToUnit(field?.placeholder)
                return taxaDataText += "\n" + taxText
            }
            return ""
        })
    }
    Object.values(detalhesDaAvaliacao).map(detAval => detAvalText += "\n" + detAval)
    Object.values(detalhesDoCalculo).map(detCalc => detCalcText += "\n" + detCalc)

    return [msg + taxaDataText + "\n\nDetalhes da avaliação" + detAvalText + "\n\nDetalhes do cálculo" + detCalcText]
}

export function determineParcelasData(idServico, servicoTemParcelamento, parcelasPagamento, taxaTotal, outorga)
{

    const numParcelas = opcoesParcelamento.indexOf(parcelasPagamento) + 1
    const parcelarTaxaTotal = (idServico === "Alvara" || idServico === "AlvaraAcresReg") || (idServico === "GuiaPag" )
    const valoresParcelas = servicoTemParcelamento && 1 < numParcelas ? CalcularParcelas(taxaTotal, outorga, numParcelas, parcelarTaxaTotal) : null

    return determineParcelasTexto(parcelarTaxaTotal, parcelasPagamento, valoresParcelas)

}


export async function AutoCompleteAddressObra()
{
    return await AutoCompleteAddress("cepObra", "bairroObra", "complementoObra", "logradouroObra")
}

export function preencherComDadosProtocolo(dadosProtocolo)
{    
    getField(docField.nomeProprietario().props.Name).value = dadosProtocolo?.proprietario?.nomeProprietario
    getField(docField.cpfCnpjProprietario().props.Name).value = dadosProtocolo?.proprietario?.cpfCnpjProprietario
    getField(guiaField.cepProprietario().props.Name).value = dadosProtocolo?.enderecoProprietario?.cepProprietario
    getField(guiaField.bairroProprietario().props.Name).value = dadosProtocolo?.enderecoProprietario?.bairroProprietario
    getField(guiaField.numPortaProprietario().props.Name).value = dadosProtocolo?.enderecoProprietario?.numPortaProprietario
    getField(guiaField.logradouroProprietario().props.Name).value = dadosProtocolo?.enderecoProprietario?.logradouroProprietario
    getField(guiaField.complementoProprietario().props.Name).value = dadosProtocolo?.enderecoProprietario?.complementoProprietario
}

export function MontarFatoGerador(idServico, fatoGeradorProtocolo, tipoServico, tipoImovel)
{
    // TODO corrigir fato gerador. Anuencia tem que ser diferente de alvara
    const fatosGeradoresEspecificos = 
    {
        Protocolo: fatoGeradorProtocolo,
        DeclAtendTermoCompr: "Documento emitido para atestar que foram atendidas as pendências elencadas no Termo de Compromisso"
    }

    const fatoGerador = fatosGeradoresEspecificos[idServico]
    const parcelaFatoGer = fatoGerador !== "" ? " - " : fatoGerador + " "    

    return `${tipoServico}${parcelaFatoGer}${tipoImovel ?? ""}`
}

export function autoFillGuia(procData, guiaData)
{
    if (!guiaData) { console.log("Aviso: Tentando preencher formulário da guia sem dados da guia") ; return }

    const fillFormData =
    {
        ...guiaData,
        numProc: procData?.numProc,
        anoProc: procData?.anoProc,
        parcelasPagamento: opcoesParcelamento[Number(guiaData.detalhesGuia.qtdParcelas - 1)]
    }

    const readonlyFields =
    {
        numProc: procData?.numProc,
        anoProc: procData?.anoProc
    }
    
    autoFill(fillFormData, false, readonlyFields)
    // setReRenderForInputMasks(!reRenderForInputMaks) // search for export functional update to see if applies here
}

export async function checkTemGuiaProtocolo(editar, tipoServico, subTipoDoc)
{

    if (editar) { return }

    const numProc = document.getElementsByName("numProc")[0].value
    const anoProc = document.getElementsByName("anoProc")[0].value

    if (numProc === "" || anoProc === "") { return }

    const proc = await PegarProcesso(numProc, anoProc)

    if (!proc?.documentos || proc?.documentos.length <= 0) { return }

    const guiasProtocolo = proc?.documentos.filter(doc => doc.tipoDoc === "GuiaPag" && doc.fatoGerador.includes("Protocolo de Entrada"))

    if (!guiasProtocolo || guiasProtocolo.length <= 0) { return }

    let guiasDoMesmoTipoDoc = guiasProtocolo.filter(guia => guia.detalhesGuia.taxInputs.fatoGeradorProtocolo.includes(tipoServico))
    if (!!subTipoDoc)
    {
        guiasDoMesmoTipoDoc = guiasProtocolo.filter(guia => guia.detalhesGuia.taxInputs.subTipoDoc.includes(subTipoDoc))
    }

    if (!guiasDoMesmoTipoDoc || guiasDoMesmoTipoDoc.length !== 1) { return }

    return guiasDoMesmoTipoDoc[0]

}

export async function handleAvisoGuiaExistente(fatoGeradorExistente, servicoTaxa, taxInputs, editar, setInformedProcData, setShowAvisoGuiaExistente)
{
    setShowAvisoGuiaExistente(false)

    if (editar) { return }

    const numProc = document.getElementsByName("numProc")[0].value
    const anoProc = document.getElementsByName("anoProc")[0].value

    if (numProc === "" || anoProc === "") { return }

    const proc = await PegarProcesso(numProc, anoProc)

    if (!proc?.documentos || proc?.documentos.length <= 0) { return }

    const fatoGer = fatoGeradorExistente ?? MontarFatoGerador(servicoTaxa.id, taxInputs.fatoGeradorProtocolo, servicoTaxa.nome, taxInputs.tipoImovel ?? taxInputs?.subTipoDoc)
    const guiasComMesmoFatoGerador = proc.documentos.filter(doc => doc.fatoGerador === fatoGer)
    if (0 < guiasComMesmoFatoGerador.length)
    {
        setInformedProcData(proc)
        setShowAvisoGuiaExistente(true)
    }
}


export function onChangeCPFCNPJ(setSwitchCNPJ)
{
    const switchCNPJField = document.getElementsByName("switchCNPJ")[0]
    setSwitchCNPJ(switchCNPJField === undefined ? false : switchCNPJField.checked)
}

export function temParcelamento(fatoGeradorExistente, idServico)
{
    return fatoGeradorExistente ?
            (fatoGeradorExistente.includes("Alvará") || fatoGeradorExistente.includes("Regularização")) :
            (idServico === "Alvara" | idServico === "AlvaraAcresReg" | idServico === "CertRegul")
}

export async function handleSubmit(event, setLoading, setValidated, guiaData, servicoTaxa, taxInputs, taxResults, editar, procId, showAlert)
{
    const form = event.currentTarget
    event.preventDefault()

    if (!form.checkValidity() | !dropdownsAreValid())
    {
        event.stopPropagation()
        setValidated(false)
        const message = WarningIncompleteInputMessage()
        showAlert(message.variant, message.header, message.body)
        window.scrollTo(0, 0)

        return
    }

    if (!userLogado) { alert(MSG.PERMISSAO.LOGADO) ; return }
    if (!userHasAccess(ROLE.ANALISTA)) { alert(MSG.PERMISSAO.ANALISTA) ; return }
    
    setValidated(true)
    setLoading(true)
    const formData = getFormData(form)
    // TODO passar essas coisas pra montagem do body

    let parcelasTexto = determineParcelasData(servicoTaxa.id, temParcelamento(guiaData?.fatoGerador, servicoTaxa.id), formData.parcelasPagamento, taxResults.taxaTotal, taxResults.outorga)
    if (guiaData)
    {
        parcelasTexto = parcelasTexto || guiaData.detalhesGuia.parcelamento
    }

    let obsTexto = guiaData ? "" : determineTaxData(taxResults.detalhesDaAvaliacao, taxResults.detalhesDoCalculo, taxInputs)
    if (guiaData)
    {
        let linesObs = guiaData.detalhesGuia.detalhesTaxa[0].split("\n")
        linesObs = linesObs.filter(det => !det.includes("parcela") && !det.includes("parcelada"))
        for (let i = 0 ; i <= linesObs.length - 1 ; i += 1)
        {
            if (i === 0)
            {
                obsTexto += linesObs[i]
                continue
            }

            obsTexto += "\n" + linesObs[i]
        }
    }

    const fatoGer = 
        guiaData?.fatoGerador ??
        MontarFatoGerador(servicoTaxa.id, taxInputs.fatoGeradorProtocolo, servicoTaxa.nome, taxInputs.tipoImovel ?? taxInputs?.subTipoDoc)

    const guiaBody = criarDocBodyBD("GuiaPag", taxInputs, formData, taxResults, fatoGer, obsTexto + parcelasTexto, servicoTaxa.id)

    try
    {
        var resultsChamada
        const filename = "Guia de pagamento - Proc N° " + formData.numProc + "-" + formData.anoProc

        if (!editar)
        {
            resultsChamada = await SalvarDocumentoCriarProcesso(formData.numProc, formData.anoProc, guiaBody, filename)
        }
        else
        {
            let newDocData = guiaBody
            newDocData.fatoGerador = guiaData.fatoGerador
            newDocData.subTipoDoc = guiaData.subTipoDoc
            newDocData.detalhesGuia.tipoDocDestino = guiaData.detalhesGuia.tipoDocDestino
            newDocData.detalhesGuia.subTipoDocDestino = guiaData.detalhesGuia.subTipoDocDestino
            newDocData.autenticacao = guiaData.autenticacao
            resultsChamada = await EditarDocumento(procId, guiaData.id, newDocData, filename)
        }

        if(resultsChamada.error)
        {
            const message = ErrorChamadaApi("gerador de documentos", resultsChamada.error)
            showAlert(message.variant, message.header, message.body)
            window.scrollTo(0, 0)
        }
        else
        {
            const message = SuccessDocumentoGerado()
            showAlert(message.variant, message.header, message.body)        
            window.scrollTo(0, 0)
        }

        
        // const guiaResults = await NovoGerarDoc(guiaBody, filename, formData.numProc, formData.anoProc, true)
    
    }
    catch
    {
        console.log("Erro ao tentar salvar processo com guia de pagamento no banco de dados")
    }

    setLoading(false)

}